module.exports = __webpack_public_path__ + "img/CDNX-dark-start_spinner.eed4c6.svg";